import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setRiskScope, SetRiskScopeBody } from "@/api/risk";
import { RiskQueryKeys } from "@/tanstackQuery/queries/risk";

export interface SetRiskScopeOptions {
  onSuccess?: (data: void, variables: SetRiskScopeBody) => void;
  onError?: (error: Error) => void;
}

// Watching / unwatching a league or country changes both the scope and which
// matches the list shows.
export const useSetRiskScope = (options?: SetRiskScopeOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: SetRiskScopeBody) => setRiskScope(body),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: [RiskQueryKeys.Scope] });
      queryClient.invalidateQueries({ queryKey: [RiskQueryKeys.Matches] });
      options?.onSuccess?.(data, variables);
    },
    onError: options?.onError,
  });
};
